import _ from "lodash";
import {flatten} from "@/helper/characteristic/Flatten";
import {isDefined} from "@/helper/Value";

export function isSelected (selectedItems, characteristic)
{
	return isDefined(
		_.find(selectedItems, item => item.item.id === characteristic.id)
	);
}

export function hasSelectedChilds (selectedItems, characteristic)
{
	const childIds = _.map(characteristic.children, 'id');

	if (childIds.length === 0)
	{
		return false;
	}

	return _
		.filter(
			selectedItems,
			selectedItem => _.includes(childIds, selectedItem.item.id)
		)
		.length > 0;
}

export function hasSelectedChildsToLastLevel (selectedItems, characteristic)
{
	const selectedIds = _.map(selectedItems, 'item.id');

	const allChildrenIds = _.map(
		flatten(characteristic.children || []),
		'id'
	);

	return _.intersection(selectedIds, allChildrenIds).length > 0;
}

export function filterLastLevel (items)
{
	// item can be undefined for freeText items (software special)
	return _.filter(
		items,
		item => !isDefined(item.item) || !hasSelectedChilds(items, item.item)
	);
}
